import { render, staticRenderFns } from "./DomainConnectionModal.vue?vue&type=template&id=fc08bc0c&scoped=true&"
import script from "./DomainConnectionModal.vue?vue&type=script&lang=js&"
export * from "./DomainConnectionModal.vue?vue&type=script&lang=js&"
import style0 from "./DomainConnectionModal.vue?vue&type=style&index=0&id=fc08bc0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc08bc0c",
  null
  
)

export default component.exports